import { useParams, useSearchParams } from "react-router-dom";
import api from "../../services/api";
import { useState, useEffect } from "react";
import { confirmAlert } from "react-confirm-alert";
import 'react-confirm-alert/src/react-confirm-alert.css';
import "./banco.css";
import { formatar } from "../../services/react-format";

function Banco(props){
  const [searchParams       , setSearchParams]    = useSearchParams();
  const [banco_id           , setBancoID          ]= useState(-1);
  const [banco_nome         , setBancoNome        ]= useState("");
  const [cod_banco          , setBancoCodigo      ]= useState("");
  const [banco_agencia      , setBancoAgencia     ]= useState("");
  const [banco_agencia_dv   , setBancoAgenciaDv   ]= useState("");
  const [banco_conta        , setBancoConta       ]= useState("");
  const [banco_conta_dv     , setBancoContaDv     ]= useState("");
  const [banco_saldo_inicial, setBancoSaldoInicial]= useState(0);
  const [alterado           , setAlterado         ]= useState(false);
  var CNPJCliente    = searchParams.get("cnpj");
  var UsuarioSpartan = searchParams.get("usuario");  

  useEffect(() => {
    setBancoID(props.banco_id);
    setBancoNome(props.banco_nome);
    setBancoCodigo(props.cod_banco);
    setBancoAgencia(props.banco_agencia);
    setBancoAgenciaDv(props.banco_agencia_dv);
    setBancoConta(props.banco_conta);
    setBancoContaDv(props.banco_conta_dv);
    setBancoSaldoInicial(props.banco_saldo_inicial);
  },[props])


  // function handleValor(e){
  //   let obj = formatar(e.target,"money"); //target = objeto input que coloquei a funcao la em baixo
  //   console.log(obj)
  //   console.log('Valor Saldo: ' + obj.value);
  //   setSaldo(obj.value);
  //   setAlterado(true);    
  // }  
  function Excluir(props){
    confirmAlert({
        title: 'Exclusão',
        message: 'Confirma exclusão de '+props.banco_nome+ '('+props.banco_id+ ')?',
        buttons: [
          {
            label: 'Sim',
            onClick: (bancoid=props.banco_id) => {
              
              console.log("Apagando banco " + props);
              console.log("/erp/bancos?CNPJ="+CNPJCliente+"&usuario="+UsuarioSpartan+"&id="+bancoid)
              api.delete("/erp/bancos?CNPJ="+CNPJCliente+"&usuario="+UsuarioSpartan+"&id="+bancoid)
              .then((resp) => {  //aguarda a resposta do comando get anterior
                console.log(resp.data);
                if (resp.data.status == 'OK') {
                  props.onClose();
                }else{
                  alert(resp.data.mensagem);
                }
              })
              .catch((err) => {
                  alert('Falha ao excluir ID: '+props.banco_id + ' Mensagem: '+err) ;
              });
            }
            
          },
          {
            label: 'Não',
            onClick: () => {}
          }
        ]
      });
  };

  function Salvar(props){   
    const banco_params = {
      banco_id,
      banco_nome,
      cod_banco,
      banco_agencia,
      banco_agencia_dv,
      banco_conta,
      banco_conta_dv,
      banco_saldo_inicial      
    };                        
    api.post("/erp/bancos?CNPJ="+CNPJCliente+"&usuario="+UsuarioSpartan,banco_params)
    .then((resp) => {  //aguarda a resposta do comando get anterior
      if (resp.status ==201){
        console.log("/erp/bancos?CNPJ="+CNPJCliente+"&usuario="+UsuarioSpartan)
        console.log('Resp.Data: '+ resp.data);
        //alert('Banco incluído. ID: '+resp.data.banco_id);                      
        props.onClose();
        setBancoAgencia("");
        setBancoAgenciaDv("");
        setBancoCodigo("");
        setBancoNome("");
        setBancoID(-1);
        setBancoConta("");
        setBancoContaDv("");
        setBancoSaldoInicial(0);
        setAlterado(false);
      } else {
        alert("O seguinte erro foi retornado: "+resp.data.mensagem);
      }

    })
    .catch((err) => {
        alert('Falha ao gravar dados: '+err);
    });      
  };
  
  function SalvarAlteracao(props){   
    const banco_params = {
      banco_id,
      banco_nome,
      cod_banco,
      banco_agencia,
      banco_agencia_dv,
      banco_conta,
      banco_conta_dv,
      banco_saldo_inicial           
    };     
    if (banco_id > 0) {
      if (banco_nome == "") {
        { 
          alert("Qual o nome do banco?");
          return;
        }
      };

      if (cod_banco == "") {
        { 
          alert("Preencha o código do banco");
          return;
        }
      };
        
      if (banco_agencia == "") {
        { 
          alert("Falta o número da agência");
          return;
        }
      };      

      if (banco_conta == "") {
        { 
          alert("Preencha a número da conta");
          return;
        }
      };      
    };


      console.log("/erp/bancos?CNPJ="+CNPJCliente+"&usuario="+UsuarioSpartan+"&banco_id="+props.banco_id,props);
      console.log('Parâmetros Props: ' + JSON.stringify(props));
      console.log('Parâmetros banco_params: ' + JSON.stringify(banco_params));
      api.put("/erp/bancos?CNPJ="+CNPJCliente+"&usuario="+UsuarioSpartan+"&banco_id="+banco_id, banco_params)
      .then((resp) => {  //aguarda a resposta do comando get anterior
        console.log(JSON.stringify(resp.data));
        if (resp.status ==200){
          setAlterado(false) ;
          console.log('Alteração: '+ JSON.stringify(resp.data));
          props.onClose();
        } else {
          alert("O seguinte erro foi retornado: "+resp.data.mensagem);
        }

      })
      .catch((err) => {
          alert('Falha ao gravar dados: '+err);
      });    
      // confirmAlert({
      //     title: 'Grava alteração',
      //     message: 'Confirma alteração destes dados?',
      //     buttons: [
      //       {
      //         label: 'Sim',
      //         onClick: () => {
      //           // console.log("/erp/bancos?CNPJ="+CNPJCliente+"&usuario="+UsuarioSpartan+"&banco_id="+props.banco_id,props);
      //           // console.log('Parâmetros: ' + JSON.stringify(props));
      //           api.put("/erp/bancos?CNPJ="+CNPJCliente+"&usuario="+UsuarioSpartan+"&banco_id="+props.banco_id, props)
      //           .then((resp) => {  //aguarda a resposta do comando get anterior
      //             if (resp.status ==200){
      //               console.log('Alteração: '+ JSON.stringify(resp.data));
      //               console.log('Valor Saldo: '+ resp.data.saldo);
      //               props.onClose();
      //             } else {
      //               alert("O seguinte erro foi retornado: "+resp.data.mensagem);
      //             }

      //           })
      //           .catch((err) => {
      //               alert('Falha ao gravar dados: '+err);
      //           });
  
      //         }
      //       },
      //       {
      //         label: 'Não',
      //         onClick: () => {}
      //       }
      //     ]
      //   });
  };
  
    return <form className="row g-2 needs-validation mt-0 mb-0" novalidate id={"bancoid_"+props.banco_id}>  
    {/* <div className="input-group" id={props.banco_id}> */}
      <div className="col-md-1">
          {/* <label for="banco-agencia" className="form-label">Agência</label> */}
          <input type="text" id="banco-codigo" className="form-control"  value={cod_banco} maxLength="3" onChange={(e) => {setBancoCodigo(e.target.value); setAlterado(true)}} readOnly={props.banco_id==0}/>
      </div>    
      <div className="col-md-3" >
        {/* <label for="banco-nome" className="form-label">Banco</label> */}
        <input type="text" id="banco-nome" className="form-control" maxLength="15"
               list="datalistOptions" 
               value = {banco_nome}
               onChange={(e) => {setBancoNome(e.target.value);setAlterado(true);}} 
               readOnly={props.banco_id==0}/>
        <datalist id="datalistOptions">
          <option value="Banco Do Brasil"/>
          <option value="Bradesco S.A."/>
          <option value="Digio S.A."/>
          <option value="Nubank"/>
          <option value="PagSeguro S.A."/>
          <option value="Mercado Pago"/>
          <option value="Next Bank"/>
          <option value="Sofisa S.A."/>
          <option value="Banco Inter S.A"/>
          <option value="Itaú Unibanco"/>
          <option value="Caixa Econômica"/>
          <option value="Santander"/>
          <option value="Banco Original"/>
          <option value="Bancoob S.A."/>
          <option value="Votorantim"/>
          <option value="Neon Pagamentos"/>
          <option value="Banrisul"/>
          <option value="Banco Mercantil"/>
          <option value="Banco Safra"/>
        </datalist>

      </div>    
      <div className="col-md-1">
        {/* <label for="banco-agencia" className="form-label">Agência</label> */}
        <input type="text" id="banco-agencia" className="form-control" value ={banco_agencia} onChange={(e) => {setBancoAgencia(e.target.value); setAlterado(true)}}  maxLength="5" readOnly={props.banco_id==0}/>
        {/* <input type="text" id="nome"          className="form-control" onChange={(e) => setNome(e.target.value)} value={nome}  placeholder="Categoria" /> */}
      
      </div>    
      <div className="col-md-1">
        {/* <label for="banco-digito" className="form-label">Dígito</label> */}
        <input type="number" id="banco-digito" className="form-control" value ={banco_agencia_dv} maxLength="1" onChange={(e) => {setBancoAgenciaDv(e.target.value); setAlterado(true)}} readOnly={props.banco_id==0}/>
      </div>    
      <div className="col-md-2">
        {/* <label for="banco-conta" className="form-label">Conta</label> */}
        <input type="text" id="banco-conta" className="form-control"   value ={banco_conta} maxLength="12" onChange={(e) => {setBancoConta(e.target.value); setAlterado(true)}} readOnly={props.banco_id==0}/>
      </div>    
      <div className="col-md-1">
        {/* <label for="banco-conta-digito" className="form-label">Dígito</label> */}
        <input type="text" id="banco-conta-digito" className="form-control"   value ={banco_conta_dv} maxLength="1" onChange={(e) => {setBancoContaDv(e.target.value); setAlterado(true)}} readOnly={props.banco_id==0}/>
      </div>    
      <div className="col-md-2">
        {/* <label for="banco-saldo" className="form-label">Saldo</label> */}
        <input type="text" 
               id="banco-saldo" 
               className="form-control" 
               style={{"text-align": "right"}} 
               value ={banco_saldo_inicial} 
               onChange={(e) => {setBancoSaldoInicial(e.target.value); setAlterado(true)}}
              //  onChange={handleValor}
        />
      </div>    
      <div className="col-md-1" id="div-botoes">
        {(props.banco_id<0) ?
          <button onClick={() => Salvar(props)} className="btn btn-primary btn-sm" type="button" id="button-salvar"><i className="bi bi-floppy"></i></button>
           :<></>}
        {(props.banco_id>=0) && (alterado) ?
          <button onClick={() => SalvarAlteracao(props)} className="btn btn-success btn-sm" type="button" id="button-alterar"><i className="bi bi-floppy"></i></button>
           :<></>} 
        {props.banco_id>0 ?
          <button onClick={() => Excluir(props)} className="btn btn-danger btn-sm" type="button" id="button-excluir"><i className="bi bi-trash3-fill"></i></button>
           :<></>} 
      </div>    
    </form>



}

export default Banco; 

// confirmAlert({
//   title: 'Grava Dados',
//   message: 'Confirma inclusão destes dados?',
//   buttons: [
//     {
//       label: 'Sim',
//       onClick: () => {
//         api.post("/erp/bancos?CNPJ="+CNPJCliente+"&usuario="+UsuarioSpartan,banco_params)
//         .then((resp) => {  //aguarda a resposta do comando get anterior
//           if (resp.status ==201){
//             console.log("/erp/bancos?CNPJ="+CNPJCliente+"&usuario="+UsuarioSpartan)
//             console.log('Resp.Data: '+ resp.data);
//             //alert('Banco incluído. ID: '+resp.data.banco_id);                      
//             props.onClose();
//             setBancoAgencia("");
//             setBancoAgenciaDv("");
//             setBancoCodigo("");
//             setBancoNome("");
//             setBancoID(-1);
//             setBancoConta("");
//             setBancoContaDv("");
//             setBancoSaldoInicial(0);
//             setAlterado(false);
//           } else {
//             alert("O seguinte erro foi retornado: "+resp.data.mensagem);
//           }

//         })
//         .catch((err) => {
//             alert('Falha ao gravar dados: '+err);
//         });

//       }
//     },
//     {
//       label: 'Não',
//       onClick: () => {}
//     }
//   ]
// });